// extracted by mini-css-extract-plugin
export var body = "industriesListing-module--body--lmEyj";
export var border = "industriesListing-module--border--JOZYI";
export var button = "industriesListing-module--button--FhEkr";
export var edu = "industriesListing-module--edu--rnx0p";
export var imageContainer = "industriesListing-module--imageContainer--J2s1L";
export var industriesCard = "industriesListing-module--industriesCard--3BLEW";
export var industriesListing = "industriesListing-module--industriesListing--oWmhB";
export var item = "industriesListing-module--item--UMO5W";
export var plug = "industriesListing-module--plug--HGxeB";
export var rocketIcon = "industriesListing-module--rocketIcon--25whm";
export var rocketIconLast = "industriesListing-module--rocketIconLast--lXTMb";
export var sbShowMain = "industriesListing-module--sb-show-main--HxgLW";
export var title = "industriesListing-module--title--SqKJ8";
export var twoItems = "industriesListing-module--twoItems--vcxLQ";